import {VuexModule, Module, Action, Mutation} from "vuex-module-decorators";
import Table from "@/model/table";


@Module({namespaced: true})
export default class TableModule extends VuexModule {
  public table: Table = null;

  @Mutation
  set(table: Table): void {
    this.table = table;
  }

  @Action({rawError: true})
  setTable(table: Table) {
    this.context.commit('set', table);
  }

  @Action({ rawError: true })
  clear() {
    this.context.commit("set", null);
  }

  get getTable(): Table {
    return new Table(this.table);
  }

  get isActiveAllYouCan(): boolean {
    return this.table?.tables[0]?.TBL_FREE === '1'
      || this.table?.tables[0]?.TBL_DFREE === '1';
  }
}
